import { render, staticRenderFns } from "./tFooterInfo.vue?vue&type=template&id=87e04e32"
import script from "./tFooterInfo.vue?vue&type=script&lang=ts"
export * from "./tFooterInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports